import axios from  'axios';
import config from './../../config';

export function openDrawer(){
    return {
        type:"OPEN_DRAWER"
    }
}

export function closeDrawer(){
    return {
        type:"CLOSE_DRAWER"
    }
}

export function openPDFViewer(data){
    return {
        type:"OPEN_PDF_VIEWER",
        payload:data
    }
}

export function closePDFViewer(){
    return {
        type:"CLOSE_PDF_VIEWER"
    }
}

export function getParams(){
    return{
        type : 'GET_PARAMS',
        payload: axios.get(config.ws_path+'/public/params')
    }
}


// WEBPACK FOOTER //
// ./src/actions/shared/actions_shared_1.js